import { render, staticRenderFns } from "./AddNewMetadata.vue?vue&type=template&id=3d716428&"
import script from "./AddNewMetadata.vue?vue&type=script&lang=ts&"
export * from "./AddNewMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewMetadata.vue?vue&type=style&index=0&id=3d716428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports